import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Loading, ProductionStepEntryForm } from "@components";
import { useAuth } from "@hooks";
import { Layout } from "./PageLayouts";

export function ProductionStepEntryPage() {
  const { user } = useAuth();
  const { productionStep } = useParams();
  const [searchParams] = useSearchParams();
  const initialModuleId = searchParams.get("moduleId");

  return (
    <Layout
      variant="centered"
      align="center"
      isProtected
      showLoggedInText={true}
    >
      {productionStep && user ? (
        <ProductionStepEntryForm
          productionStep={productionStep}
          user={user}
          initialModuleId={initialModuleId}
        />
      ) : (
        <Loading />
      )}
    </Layout>
  );
}
